import React, { useEffect } from 'react';
import styles from './VerificationCodeInput.module.scss';
import clsx from 'clsx';
import { ErrorBanner } from '../ErrorBanner/ErrorBanner';

type VerificationCodeInputProps = {
    code: string;
    onChange: (code: string) => void;
    isError?: boolean;
};

// eslint-disable-next-line react/display-name
export const VerificationCodeInput: React.FC<VerificationCodeInputProps> = ({
    onChange,
    code,
    isError,
}) => {
    const emptyValues = Array.from({ length: 6 }, () => '-');
    const inputRef = React.useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            setTimeout(() => {
                inputRef?.current?.focus();
            });
        }
    }, [isError]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (/[0-9]/.test(e.key) && code.length < 6) {
            onChange(code + e.key);
        }
        if (e.key === 'Backspace') {
            onChange(code.slice(0, -1));
        }
    };

    const onMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 6) {
            return;
        }
        onChange(value);
    };

    return (
        <>
            <input
                type="text"
                ref={inputRef}
                className={styles.HiddenInput}
                onKeyDown={handleKeyDown}
                onChange={onMobileChange}
                onPaste={(e) => {
                    onChange(e.clipboardData.getData('text').slice(0, 6));
                }}
            />
            <div
                className={clsx(styles.VerificationCodeInput, {
                    [styles.ErrorMargin]: isError,
                })}
                onClick={() => {
                    inputRef.current?.focus();
                }}
                onKeyDown={handleKeyDown}
                onPaste={(e) => {
                    onChange(e.clipboardData.getData('text').slice(0, 6));
                }}
            >
                {emptyValues.map((input, index) => (
                    <div
                        key={input + index}
                        className={clsx(styles.LetterBox, {
                            [styles.Letter]: !!code.split('')[index],
                            [styles.Error]: isError,
                        })}
                    >
                        {code.split('')[index] || input}
                    </div>
                ))}
            </div>
            {isError && <ErrorBanner errorText="The code is invalid." />}
        </>
    );
};
